/**
 * @generated SignedSource<<7150ffe3e6c091e08850d03cd3051607>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type SlotAvailabilityArgs = {
  bookingType: BookingType;
  facilityId: string;
  instructorIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  lessonTypeId?: string | null | undefined;
};
export type AvailableDatesListQuery$variables = {
  durationMins: number;
  endDateTime: string;
  endTime?: string | null | undefined;
  instructorId: string;
  slotAvailability?: SlotAvailabilityArgs | null | undefined;
  startDateTime: string;
  startTime?: string | null | undefined;
};
export type AvailableDatesListQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"useGetDatesListData_staffProfile">;
  } | null | undefined;
};
export type AvailableDatesListQuery = {
  response: AvailableDatesListQuery$data;
  variables: AvailableDatesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "durationMins"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDateTime"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endTime"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "instructorId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slotAvailability"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDateTime"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTime"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "instructorId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AvailableDatesListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useGetDatesListData_staffProfile"
              }
            ],
            "type": "StaffProfile",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "AvailableDatesListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "dateTimeGte",
                    "variableName": "startDateTime"
                  },
                  {
                    "kind": "Variable",
                    "name": "dateTimeLte",
                    "variableName": "endDateTime"
                  },
                  {
                    "kind": "Variable",
                    "name": "durationMins",
                    "variableName": "durationMins"
                  },
                  {
                    "kind": "Variable",
                    "name": "slotAvailability",
                    "variableName": "slotAvailability"
                  },
                  {
                    "kind": "Variable",
                    "name": "timeGte",
                    "variableName": "startTime"
                  },
                  {
                    "kind": "Variable",
                    "name": "timeLte",
                    "variableName": "endTime"
                  }
                ],
                "concreteType": "AvailabilitySlotConnection",
                "kind": "LinkedField",
                "name": "availabilitySlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailabilitySlotEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AvailabilitySlot",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "date",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "StaffProfile",
            "abstractKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b56ad19985c5be3823e26041d27b83c0",
    "id": null,
    "metadata": {},
    "name": "AvailableDatesListQuery",
    "operationKind": "query",
    "text": "query AvailableDatesListQuery(\n  $instructorId: ID!\n  $startDateTime: Datetime!\n  $endDateTime: Datetime!\n  $durationMins: Int!\n  $slotAvailability: SlotAvailabilityArgs\n  $startTime: Time\n  $endTime: Time\n) {\n  node(id: $instructorId) {\n    __typename\n    ... on StaffProfile {\n      ...useGetDatesListData_staffProfile\n    }\n    id\n  }\n}\n\nfragment useGetDatesListData_staffProfile on StaffProfile {\n  availabilitySlots(dateTimeLte: $endDateTime, dateTimeGte: $startDateTime, durationMins: $durationMins, timeGte: $startTime, timeLte: $endTime, slotAvailability: $slotAvailability) {\n    edges {\n      node {\n        id\n        date\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "062f182b306cce84f827a6a32f1e1cbb";

export default node;
